import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import apiClient from "../../../helpers/apiClient";

const INITIAL_STATISTICS = {
    inFleet: 0,
    available: 0,
    returnToday: 0,
    leavingToday: 0,
    onGoing: 0,
    reservation: 0,
    maintenance: 0,
    overDue: 0,
};

const DashboardStatsBar = () => {
    const { t } = useTranslation("topBar");
    const [loading, setLoading] = useState(true);
    const [statistics, setStatistics] = useState(INITIAL_STATISTICS);

    useEffect(() => {
        let cancelled = false;

        (async () => {
            setLoading(true);
            try {
                const result = await apiClient.get("api/stat");
                if (cancelled || result.data.success !== true) {
                    return;
                }

                setStatistics({
                    inFleet: result.data.data.cars.inFleet,
                    available: result.data.data.cars.available,
                    onGoing: result.data.data.cars.onGoing,
                    reservation: result.data.data.reservations.total,
                    maintenance: result.data.data.cars.maintenance,
                    overDue: result.data.data.cars.overdue,
                    returnToday: result.data.data.cars.returnToday,
                    leavingToday: result.data.data.cars.leavingToday,
                });
            } catch (_error) {
                /* empty */
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        })();

        return () => {
            cancelled = true;
        };
    }, []);

    const stats = [
        { key: "inFleet", label: t("inFleet") },
        { key: "available", label: t("availableToday") },
        { key: "returnToday", label: t("returnToday") },
        { key: "leavingToday", label: t("leavingToday") },
        { key: "onGoing", label: t("onGoing") },
        { key: "reservation", label: t("reservation") },
        { key: "maintenance", label: t("maintenance") },
        { key: "overDue", label: t("overDue") },
    ];

    return (
        <div
            className="grid grid-cols-2 gap-2 sm:grid-cols-4 sm:gap-3 lg:grid-cols-8"
            data-tour="dashboard-kpis">
            {/* Phones show each stat as a short row (label left, value right) so
                the eight of them take four slim rows instead of four tall ones.
                Poppins is too wide for a 4-up grid at this size: Spanish labels
                like "Mantenimiento" overflow an 80px tile. */}
            {stats.map(({ key, label }) => (
                <div
                    key={key}
                    className="flex min-w-0 flex-row-reverse items-center justify-between gap-2 rounded-2xl border border-gray-200 bg-white px-3.5 py-3 shadow-sm sm:flex-col sm:justify-center sm:gap-0.5 sm:px-2 sm:py-4 sm:text-center">
                    <div className="shrink-0 text-lg font-bold tabular-nums leading-tight text-gray-900 sm:text-xl">
                        {loading ? "-" : statistics[key]}
                    </div>
                    <div className="min-w-0 text-[13px] leading-tight text-gray-500 sm:text-sm">{label}</div>
                </div>
            ))}
        </div>
    );
};

export default DashboardStatsBar;
